<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_orthopedic_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div class="main-content">
      <div class="card investigations-card">
        <div class="investigations-header">
          <div class="header-left">
            <!-- <i class="fas fa-x-ray header-icon"></i> -->
             <span style="font-size: 2em;">⚕</span>
            <div>
              <h3>Prescriptions</h3>
              <small class="text-muted">
                Drugs Prescription(s) for this patient
              </small>
            </div>
          </div>

          <button
            class="btn btn-outline-primary"
            @click="handleShowAddTestModal"
          >
            💊 Add Prescription
          </button>
        </div>

        <div v-if="loading">
          <loader />
        </div>

        <div v-if="!loading" class="card-body">
          <div class="table-responsive">
            <table class="table investigations-table">
              <thead>
                <tr>
                  <th scope="col">Prescription Service ID</th>
                  <th scope="col">Medicine/Item Name</th>
                  <th scope="col">Dosage</th>
                  <th scope="col">Instructions</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Status</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="prescription in prescriptions"
                  :key="prescription.id"
                >
                  <th scope="row">{{ prescription.detail_id }}</th>
                  <td style="color: black">
                    <!-- {{ prescription.item_name }} -->
                    <ItemName
                      :ItemBrand="prescription.brand_name"
                      :ItemStrength="prescription.strength"
                      :ItemName="prescription.item_name"
                    />
                  </td>
                  <td>{{ prescription.dosage }}</td>
                  <td>{{ prescription.instructions }}</td>
                  <td>{{ prescription.quantity }}</td>
                  <td>
                    {{ prescription.status == "0" ? "pending" : "issued" }}
                  </td>
                  <td class="text-end">
                    <button @click="deletePrescription(prescription.detail_id)">
                      Delete prescription
                    </button>
                  </td>
                </tr>

                <tr v-if="prescriptions.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    No Prescriptions ordered for this patient
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AddPresModal
    v-if="show_add_lab_test_modal"
    @close-add-pres-modal="hideCreateTestModel"
    :store_id="2"
    :visit_id="visit_id"
    pres_type="out_prescription"
  />
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import AddPresModal from "../../visits_management/pharmacy/add_prescription_modal.vue";
import ItemName from "../../Inventory/components/ItemName.vue";
import loader from "../dialysis/loader.vue";

import full_orthopedic_head from "./full_orthopedic_head.vue";

export default {
  name: "PatientInvestigations",
  components: {
    full_orthopedic_head,
    AddPresModal,
    ItemName,
    loader,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,
      show_add_lab_test_modal: false,
      patient_id: null,
      showAddServiceModal: false,
      services: [],
      current_test: "",
      showViewModal: false,
      cash_bills_behavior: 0,
      loading: false,

      prescriptions: [],
    };
  },
  methods: {
    navigate_loc(route) {
      window.location.href = route;
    },
    handleShowAddTestModal() {
      this.show_add_lab_test_modal = true;
    },
    hideCreateTestModel() {
      this.show_add_lab_test_modal = false;
      this.callApi();
    },
    async callApi() {
      try {
        this.loadding = true;
        // const visit_id = this.$route.params.visit_id; // Assuming visit_id is in the URL params
        const url = `visit/prescriptions/${this.visit_id}`; // Adjust this based on your backend API route
        const data = await generalApiRequest(url, "GET", {}, true); // true for authFlag to pass JWT token automatically
        console.log(`visit/prescriptions/${this.visit_id}`);

        console.log(this.$route.params.visit_id);

        this.prescriptions = data.data;
        this.loadding = false;
      } catch (error) {
        console.error("Error fetching prescriptions:", error);
        this.loadding = false;
      }
    },
    async deletePrescription(id) {
      try {
        const url = `prescriptions/delete/${id}`;
        const response = await generalApiRequest(url, "DELETE", {}, true); // Delete request
        if (response.status === "success") {
          this.prescriptions = this.prescriptions.filter(
            (prescription) => prescription.id !== id
          );
        }
      } catch (error) {
        console.error("Error deleting prescription:", error);
      }
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
  },
  mounted() {
    this.callApi();
    this.mountPastRecords();
  },
};
</script>

<style scoped>
/* Card */
.investigations-card {
  margin-top: 20px;
  border-radius: 8px;
  border-left: 5px solid #0d6efd;
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

/* Header */
.investigations-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #dee2e6;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  font-size: 26px;
  color: #0d6efd;
}

/* Table */
.investigations-table {
  font-size: 0.95rem;
}

.investigations-table thead th {
  background: #fafbfc;
  font-weight: 600;
  color: #495057;
}

/* Type pills */
.type-pill {
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: 600;
}

.type-lab {
  background: #e7f1ff;
  color: #0d6efd;
}

.type-xray {
  background: #f1f3f5;
  color: #495057;
}

.type-ct {
  background: #fff3cd;
  color: #856404;
}

.type-mri {
  background: #e2e3f3;
  color: #3f51b5;
}

/* Status dots */
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-ordered {
  background: #6c757d;
}

.dot-sample {
  background: #fd7e14;
}

.dot-reported {
  background: #0d6efd;
}

.dot-reviewed {
  background: #198754;
}

.status-text {
  font-size: 0.85rem;
}

/* Buttons */
.btn-light {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.btn-light:hover {
  background: #e9ecef;
}

/* Responsive */
@media (max-width: 768px) {
  .investigations-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
